export const FLAG_GETTING_PREVENTIVE_TASK_EXECUTIONS =
  'FLAG_GETTING_PREVENTIVE_TASK_EXECUTIONS';
export const GET_PREVENTIVE_TASK_EXECUTIONS = 'GET_PREVENTIVE_TASK_EXECUTIONS';
export const CLEAR_PREVENTIVE_TASK_EXECUTIONS =
  'CLEAR_PREVENTIVE_TASK_EXECUTIONS';
export const FLAG_PREVENTIVE_TASK_EXECUTION_ACTIVITY =
  'FLAG_PREVENTIVE_TASK_EXECUTION_ACTIVITY';
export const GET_PREVENTIVE_TASK_EXECUTION = 'GET_PREVENTIVE_TASK_EXECUTION';
export const CLEAR_PREVENTIVE_TASK_EXECUTION =
  'CLEAR_PREVENTIVE_TASK_EXECUTION';
